import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth, ROLE_HOME } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Bienvenue !");
      navigate(ROLE_HOME[u.role] || "/compte");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Échec de connexion");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-secondary">
        <img src="https://images.pexels.com/photos/19661361/pexels-photo-19661361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="marché" className="w-full h-full object-cover opacity-70" />
        <div className="absolute inset-0 bg-secondary/50 flex items-end p-12">
          <div>
            <h2 className="font-display text-3xl font-bold text-white mb-2">Trouvez les meilleurs prix</h2>
            <p className="text-white/80">Comparez, économisez, réservez — en toute simplicité.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm animate-fade-up">
          <h1 className="font-display text-3xl font-bold text-secondary mb-1">Connexion</h1>
          <p className="text-muted-foreground mb-6 text-sm">Ravi de vous revoir 👋</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="vous@exemple.com" />
            </div>
            <div>
              <Label>Mot de passe</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" />
            </div>
            <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-primary hover:bg-primary/90">
              {busy ? "Connexion…" : "Se connecter"}
            </Button>
          </form>
          <p className="text-sm text-center mt-6 text-muted-foreground">
            Pas de compte ? <Link to="/register" className="text-primary font-medium">Inscrivez-vous</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
